/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BigQueryDatasetDestination } from '../models/BigQueryDatasetDestination';

export class RestoreBigQueryDatasetRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': BigQueryDatasetDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "BigQueryDatasetDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreBigQueryDatasetRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

